import { Icon, IconProps } from './Icon';

export const PaymentIcon = ({ color = 'currentColor', ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
  >
    <path
      d="M18.0625 6H6.1875C4.97938 6 4 6.97938 4 8.1875V16.3125C4 17.5206 4.97938 18.5 6.1875 18.5H18.0625C19.2706 18.5 20.25 17.5206 20.25 16.3125V8.1875C20.25 6.97938 19.2706 6 18.0625 6Z"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M4 9.75H20.25M7.125 13.9688H9V14.75H7.125V13.9688Z"
      stroke={color}
      strokeWidth="2"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
